var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.containerClass }, [
    _c(
      "fieldset",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.emitBlurred,
            expression: "emitBlurred",
          },
        ],
        class: _vm.wrapperClass,
        style: { marginTop: `${_vm.dense === true ? "0" : "8px"}` },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.emitFocused.apply(null, arguments)
          },
          mouseenter: function ($event) {
            _vm.isHovered = true
          },
          mouseleave: function ($event) {
            _vm.isHovered = false
          },
        },
      },
      [
        _c("div", { staticClass: "input-header" }, [
          _vm.label.length > 0
            ? _c(
                "div",
                {
                  staticClass: "wrapper-label v-label",
                  style: `color: ${
                    _vm.isFocused
                      ? "#47bd96"
                      : _vm.$vuetify.theme.dark
                      ? "rgba(255, 255, 255, 0.7)"
                      : "#1B6E5A"
                  }; background-color: ${
                    _vm.$vuetify.theme.dark ? _vm.labelBackground : "#FFFFFF"
                  }`,
                },
                [
                  _vm._v(" " + _vm._s(_vm.label) + " "),
                  _vm.info.length > 0
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "input-info",
                                          attrs: { size: "1em", color: "blue" },
                                        },
                                        on
                                      ),
                                      [_vm._v(" fas fa-info-circle ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3112566139
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.info))])]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "wrapper-input" }, [_vm._t("default")], 2),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }